module.exports = __webpack_public_path__ + "img/gagc4680_2.aa2a4409.svg";